import { ImageHelper } from '@/lib/helpers/image.helper'
import { ERankingSlug, RankingConfig } from '@/types/auth'

const userImages = [
  ImageHelper.getImageUrlCdn('/October2023/mceclip3_72.png'),
  ImageHelper.getImageUrlCdn('/October2023/mceclip0_14.png'),
  ImageHelper.getImageUrlCdn('/October2023/mceclip1_67.png'),
  ImageHelper.getImageUrlCdn('/October2023/mceclip2_46.png'),
]

export const getUserRankingConfig = (): RankingConfig[] => {
  return [
    {
      slug: ERankingSlug.NEW_USER,
      value: 0,
      max_value: 500000,
      image: 'header.ranking_image.new_user',
      mb_image: ImageHelper.getImageUrlCdn('/2026/01/05/rank_new.png'),
      next_ranking_image: 'header.ranking_image.silver',
      rank_image: 'header.ranking_image.new_user',
      user_image: userImages[0],
      coefficient: 0,
      coefficient_line: 30,
      coupon_description: '<b>Ưu đãi 15% (tối đa 50k)</b> cho đơn hàng bất kỳ',
    },
    {
      slug: ERankingSlug.SILVER,
      value: 500000,
      max_value: 2000000,
      image: 'header.ranking_image.silver',
      mb_image: ImageHelper.getImageUrlCdn('/2026/01/05/rank_silver.png'),
      next_ranking_image: 'header.ranking_image.gold',
      rank_image: 'header.ranking_image.silver',
      user_image: userImages[1],
      coefficient: 30,
      coefficient_line: 40,
      coupon_description: '<b>Ưu đãi 20% (tối đa 50k)</b> cho đơn hàng bất kỳ',
    },
    {
      slug: ERankingSlug.GOLD,
      value: 2000000,
      max_value: 5000000,
      image: 'header.ranking_image.gold',
      mb_image: ImageHelper.getImageUrlCdn('/2026/01/05/rank_golden.png'),
      next_ranking_image: 'header.ranking_image.platinum',
      rank_image: 'header.ranking_image.gold',
      user_image: userImages[2],
      coefficient: 70,
      coefficient_line: 30,
      coupon_description: '<b>Ưu đãi 20% (tối đa 100k)</b>cho đơn hàng bất kỳ',
    },
    {
      slug: ERankingSlug.CHAMPION,
      value: 5000000,
      max_value: Number.MAX_SAFE_INTEGER,
      image: 'header.ranking_image.platinum',
      mb_image: ImageHelper.getImageUrlCdn('/2026/01/05/rank_platinum.png'),
      rank_image: 'header.ranking_image.platinum',
      user_image: userImages[3],
      coefficient: 100,
      coefficient_line: 1,
      coupon_description: '<b>Ưu đãi 25% (tối đa 100K)</b> cho đơn hàng bất kỳ',
    },
  ]
}
